import {FC} from 'react';

import {ReportExecuted} from '../../components/Reports/report/ReportExecuted';

const ReportExecutedPage: FC = () => {
  return (
    <div>
      <ReportExecuted />
    </div>
  );
};

export default ReportExecutedPage;
